@if (isLoading()) {
  <app-loader />
} @else {
  <app-table
    #tableComponent
    [table]="table"
    [isLoading]="isLoading()"
    [rowData]="rowData()"
    [columnDefs]="columnDefs()"
    [areButtonsEnabled]="areButtonsEnabled()"
    [isSearchEnabled]="isSearchEnabled()"
    [isRecordStateFilterEnabled]="isRecordStateFilterEnabled()"
    [isPaginatorEnabled]="isPaginatorEnabled()"
    [isFixedBottomPaginator]="isFixedBottomPaginator()"
    [isSaveState]="isSaveTableState()"
    [recordState]="recordState()"
    [areExpandButtonsEnabled]="true"
    [rowGroupColumns]="rowGroupColumns()"
    [autoGroupColumnDefParams]="autoGroupColumnDef()"
    (rowClick)="onView($event)"
  >
    @if (showTagsFilter() && tagsService.get().length > 1) {
      <div tag-filters class="container-flex mt-12 mb-14">
        <app-tag-group
          (tagPressed)="onSelectedRiskLevel($event.value.toString())"
          [tags]="tagsService.get()"
          [isTagClickable]="true"
        ></app-tag-group>
      </div>
    }
  </app-table>
}

<ng-template #countryFlag let-country>
  <app-flag [country]="country" />
</ng-template>
